import { text4 } from '@osmosis/tailwind-ui/styles/text';

export const TEXT_COLOR_OPTIONS = [
  { value: `${text4}`, label: 'Default' },
  { value: 'text-wp-action-blue', label: 'Action Blue (WordPress)' },
  { value: 'text-wp-action-blue-dark', label: 'Action Blue Dark (WordPress)' },
  { value: 'text-wp-vital-orange', label: 'Vital Orange (WordPress)' },
  { value: 'text-wp-graphite', label: 'Graphite (WordPress)' },
  { value: 'text-wp-ink', label: 'Ink (WordPress)' },
  { value: 'text-wp-sand', label: 'Sand (WordPress)' },
  { value: 'text-wp-paper', label: 'Paper (WordPress)' },
  { value: 'text-wp-white', label: 'White (WordPress)' },
  { value: 'text-wp-green', label: 'Green (WordPress)' },
  { value: 'text-wp-light-green', label: 'Light Green (WordPress)' },
  { value: 'text-wp-navy', label: 'Navy (WordPress)' },
  { value: 'text-wp-light-blue', label: 'Light Blue (WordPress)' },
  { value: 'text-wp-red', label: 'Red (WordPress)' },
  { value: 'text-wp-light-orange', label: 'Light Orange (WordPress)' },
  { value: 'text-wp-black', label: 'Black (WordPress)' },
];

export const BACKGROUND_COLOR_OPTIONS = [
  { value: 'default', label: 'Default' },
  { value: 'bg-wp-action-blue', label: 'Action Blue (WordPress)' },
  { value: 'bg-wp-action-blue-dark', label: 'Action Blue Dark (WordPress)' },
  { value: 'bg-wp-vital-orange', label: 'Vital Orange (WordPress)' },
  { value: 'bg-wp-graphite', label: 'Graphite (WordPress)' },
  { value: 'bg-wp-ink', label: 'Ink (WordPress)' },
  { value: 'bg-wp-sand', label: 'Sand (WordPress)' },
  { value: 'bg-wp-paper', label: 'Paper (WordPress)' },
  { value: 'bg-wp-white', label: 'White (WordPress)' },
  { value: 'bg-wp-green', label: 'Green (WordPress)' },
  { value: 'bg-wp-light-green', label: 'Light Green (WordPress)' },
  { value: 'bg-wp-navy', label: 'Navy (WordPress)' },
  { value: 'bg-wp-light-blue', label: 'Light Blue (WordPress)' },
  { value: 'bg-wp-red', label: 'Red (WordPress)' },
  { value: 'bg-wp-light-orange', label: 'Light Orange (WordPress)' },
  { value: 'bg-wp-black', label: 'Black (WordPress)' },
];
